<template>
    <div class="form-group" v-bind:class="{ 'has-danger' : hasError }">
        <div class="row">
            <div class="col-md-3 col-xl-2 col-sm-12">
                <label class="form-control-label col-form-label" for="logo_id">{{ labelComputed }}</label>
            </div>
            <div class="col-md-9 col-xl-10 col-sm-12">
                <nuxt-zone id="nuxt-zone" ref="dropzone" :options="options" :destroyDropzone="true"></nuxt-zone>
                <span class="help-block form-control-feedback" v-if="hasError" v-text="error"></span>
            </div>
        </div>
    </div>
</template>
<script>
import Dropzone from 'nuxt-dropzone'
import LabelMixin from '~/mixins/label'
import { mapGetters } from 'vuex'
export default {
    mixins: [LabelMixin],
    props: {
        error: {
            type: String,
            required: false,
            default: '',
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    components: {
        'nuxt-zone': Dropzone,
    },
    computed: {
        ...mapGetters([
          'authToken',
        ])
    },
    data() {
        return {
            options: {
                url: '',
                method: 'post',
                Authorization: 'kappa',
                addRemoveLinks: true,
                acceptedFiles: 'image/*',
                maxFiles: 1,

            },
        }
    },

    created() {
        this.options.url = this.endpoint
        this.options.headers = {
            'Authorization': 'Bearer ' + this.authToken,
        }
    },

    mounted: function() {
        this.$refs.dropzone.dropzone.on('success', (file, response) => {
            this.$emit('success', response);
        });
    },

}
</script>

<style lang="css" scoped>

</style>
